import { EventGA4 } from "./eventGa4.model";

export class SessionStartGa4 extends EventGA4 {

  session_id_kos: string;
  ss_duration_kos:number;

  constructor(data) {
    super(data);
    this.session_id_kos = data?.session_id_kos;
    this.event = data.event
    this.ss_duration_kos = data.ss_duration_kos;
    this.funnel_name = 'KOS'
    this.sub_funnel_name=data.sub_funnel_name
  }
}
